import { Button, Flex, Modal, Text } from "@mantine/core";
import { Fragment } from "react";
import NewEntryButton from "src/generator/LogBar/_Buttons/NewEntryButton";
import { type WarningModal } from "src/generator/PortraitOrientation/PortraitSection/AddDynamicRow/AddDynamicRow";

interface IMaxRowsWarningModal {
  data: WarningModal | null;
  close: () => void;
  text: string;
  maxRows: number;
  onSelectYes?: (data: WarningModal) => void;
}

const MaxRowsWarningModal = ({
  data,
  close,
  onSelectYes,
  maxRows,
  text,
}: IMaxRowsWarningModal) => {
  const handleYes = () => {
    onSelectYes && onSelectYes(data as WarningModal);
    close();
  };
  if (!data) return null;
  return (
    <Modal
      onClose={close}
      withCloseButton={false}
      yOffset={"20dvh"}
      size={"lg"}
      opened={!!data}
      title={
        data.type === "limit"
          ? `Limit of rows has been achieved (${maxRows})`
          : data.type === "security"
            ? "Warning!"
            : data.type === "warn"
              ? "Warning!"
              : ""
      }>
      <Text ta="center">{data.type !== "limit" && text}</Text>
      <Flex w={"100%"} justify={"center"} gap={10} mt={20}>
        {data.type === "limit" ? (
          <Button onClick={close} color="blue" w={80}>
            Okay
          </Button>
        ) : data.type === "security" ? (
          <Button onClick={close} color="blue" w={80}>
            Okay
          </Button>
        ) : data.type === "warn" ? (
          <Fragment>
            <Button onClick={handleYes} color="blue" w={80}>
              Yes
            </Button>
            <NewEntryButton alternativeText="No" />
          </Fragment>
        ) : null}
      </Flex>
    </Modal>
  );
};

export default MaxRowsWarningModal;
